<script setup lang="ts">
import CustomButton from '@/components/CustomButton.vue';
import { useAuthStore } from '@/stores/auth';
import { useGlobalStore } from '@/stores/global';
import { onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';

const globalStore = useGlobalStore();
const authStore = useAuthStore();
const { t: translate } = useI18n();

const route = useRoute();
const router = useRouter();

const statusCode = route.params.statusCode ?? 404;

onMounted(() => {
    globalStore.pageTitle = getShortError();
});

function getShortError() {
    const key = `error.ErrorShort${statusCode}`;
    return translate(key) ?? translate('error.ErrorShortOther');
}

function getErrorDescription() {
    const key = `error.Error${statusCode}`;
    return translate(key) ?? translate('error.ErrorOther');
}

function goBack() {
    if (authStore.isAuthenticated) router.back();
    else router.push('/login');
}
</script>

<template>
    <v-fade-transition appear>
        <v-row class="flex-column justify-center align-center">
            <img :src="`/images/errors/${statusCode}.svg`" height="425" />
            <h1 class="my-0 text-main font-weight-black">Oeps!</h1>
            <p class="font-weight-black text-main text-center">{{ getErrorDescription() }}</p>

            <v-row class="justify-center">
                <CustomButton class="px-10" @click="goBack" text="Ga terug" />
            </v-row>
        </v-row>
    </v-fade-transition>
</template>

<style scoped>
img {
    max-width: 600px;
    margin: 0 auto;
    display: block;
}

.custom-button-setup {
    z-index: 5;
}

a {
    text-decoration: none;
}
</style>
